const reg = {
    truename: /([(\u4E00-\u9FBF|·)]+)/,
    cellphone: /^1\d{10}$/,
    email: /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
    normal: /^[a-zA-Z0-9]+$/,
    char: /^[0-9a-zA-Z\s\u2000-\u206F\u3000-\u303F\uFF00-\uFFFF\u4E00-\u9FBF]+$/,
    phone: /^[0-9-_+().\s]+$/,
    number: /^[0-9]+$/,
    money: /^(-)?[\d,]+(\.\d{1,2})?$/,
    password: /^(?![0-9]+$)(?![a-zA-Z]+$)(?![^0-9a-zA-Z]+$).{8,20}$/,
    trade: /^([0-9]){6}$/,
    date: /^(\d{2,4})-(\d{1,2})(-(\d{1,2}))?$/,
    datetime: /^((\d{2,4})-(\d{1,2})(-(\d{1,2}))?)?\s{0,1}((\d{1,2}):(\d{1,2})(:(\d{1,2}))?)?$/,
    english: /[a-zA-Z]/g, // 英文
    nullstring: /[\s]/g, // 空字符
    punctuation: /[\u2000-\u206F]/g, // 标点
    punctuationSymbol: /[\u3000-\u303F]/g, // 标点
    fullangle: /[\uFF00-\uFFFF]/g, // 全角
    chinese: /[\u4E00-\u9FBF]/g, // 中文
    accountName: /^[a-zA-Z]([0-9a-zA-Z]{0,15})$/,
    truenameE: /^[\u4e00-\u9fa5]{1,16}$|^[a-zA-Z]{1,32}$/,
    image: /\.(png|gif|jpg|jpeg|tiff|bmp)(\?.*)?$/,
    allowFiles: /\.(jpg|jpeg|gif|bmp|png|tiff|pdf)$/,
    allowExcel: /\.(xls|xlsx)$/,
    allFilesFormat: /\.(png|gif|jpg|jpeg|tiff|bmp|rar|zip|pdf|doc|docx|xls|xlsx|csv)$/,
    allowZip: /\.(rar|zip|7z|gz)$/,
};
export default reg;
